import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Echo admin module — `/echo` on console.francisquini.ai.
 *
 * Tier 3 Dashboard 3.2 (Echo telemetry catalog). Spec:
 *   docs/cockpit/dashboards/tier-3-decision-quality.md §3.2
 *
 * Answers "Que eventos a gente declara e quais a gente realmente vê?" —
 * surface × event_type coverage matrix, raw event search/detail (PII
 * redacted), producers registry. Surface is `'admin'` — registered only on
 * the console host. Each page also wraps `<RequireAdmin>` for defence-in-depth.
 */
export const manifest: ModuleManifest = {
  module_id: 'echo',
  display_name: 'Echo',
  surface: 'admin',
  routes: [
    {
      path: '/echo',
      component: () =>
        import('@/modules/echo').then((m) => ({ default: m.EchoHomePage })),
      title: 'Echo — Dashboard',
      permissions: [],
    },
    {
      path: '/echo/catalog',
      component: () =>
        import('@/modules/echo').then((m) => ({ default: m.EchoCatalogPage })),
      title: 'Echo — Catálogo de cobertura',
      permissions: [],
    },
    {
      path: '/echo/events',
      component: () =>
        import('@/modules/echo').then((m) => ({ default: m.EchoEventsPage })),
      title: 'Echo — Eventos',
      permissions: [],
    },
    {
      path: '/echo/events/$eventId',
      component: () =>
        import('@/modules/echo').then((m) => ({
          default: m.EchoEventDetailPage,
        })),
      title: 'Echo — Detalhe do evento',
      permissions: [],
    },
    {
      path: '/echo/producers',
      component: () =>
        import('@/modules/echo').then((m) => ({
          default: m.EchoProducersPage,
        })),
      title: 'Echo — Producers',
      permissions: [],
    },
  ],
}
